/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ForwardHelpdeskMessagePayload
 */
export interface ForwardHelpdeskMessagePayload {
    /**
     * 
     * @type {string}
     * @memberof ForwardHelpdeskMessagePayload
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ForwardHelpdeskMessagePayload
     */
    message?: string;
}

/**
 * Check if a given object implements the ForwardHelpdeskMessagePayload interface.
 */
export function instanceOfForwardHelpdeskMessagePayload(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function ForwardHelpdeskMessagePayloadFromJSON(json: any): ForwardHelpdeskMessagePayload {
    return ForwardHelpdeskMessagePayloadFromJSONTyped(json, false);
}

export function ForwardHelpdeskMessagePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): ForwardHelpdeskMessagePayload {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function ForwardHelpdeskMessagePayloadToJSON(value?: ForwardHelpdeskMessagePayload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'message': value.message,
    };
}

